import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { formatDate } from '@/utils/dateHelper';
import {
  columnDate,
  columnRowCount,
  columnStatus,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import { dictionaryReportsEndpoint } from '@/constants/urls';
import { states } from '@/constants/lifecycle';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import SimpleCell from '@/components/table/SimpleCell';
import { dictionaryReportDownload } from '../actions';
import findDictionaryReportType from '../helper';
import DictionaryValidationStatusCell from '../components/DictionaryValidationStatusCell';
import DictionaryReportToolsMenu from '../components/DictionaryReportToolsMenu';

const DictionaryReportsTableRow = ({
  category,
  code,
  upward,
  downloadStart,
  isDownloading,
  columns,
  reportId,
  reportName,
  reportDate,
  rowCount,
  reportType,
  validationStatus,
}) => (
  <NameDescriptionRow
    asHref
    columns={columns}
    disabled={isDownloading}
    href={dictionaryReportsEndpoint(code, reportId, reportType)}
    icon="file"
    nameMessageId={isDownloading ? 'icon.download.preparing' : `icon.dictionary.${reportType}.report`}
    loading={isDownloading}
    name={reportName}
    onClick={() => downloadStart('downloads', code, reportType, { id: reportId, name: reportName }, true)}
  >
    {hasColumn(columns, columnDate) && (<SimpleCell content={reportDate ? formatDate(reportDate) : null} />)}
    {hasColumn(columns, columnStatus) && (<DictionaryValidationStatusCell status={validationStatus} />)}
    {hasColumn(columns, columnRowCount) && (<SimpleCell textAlign="right" content={rowCount} />)}
    {hasColumn(columns, columnTools) && (
    <Table.Cell collapsing>
      <DictionaryReportToolsMenu
        category={category}
        code={code}
        downloadStart={downloadStart}
        isDownloading={isDownloading}
        upward={upward}
        report={{ id: reportId, name: reportName }}
        reportType={reportType}
      />
    </Table.Cell>
    )}
  </NameDescriptionRow>
);

const mapStateToProps = ({
  datasetReports: { dictionaryReports },
}, {
  category, code, reportId, reportType,
}) => {
  const report = findDictionaryReportType(dictionaryReports, category, code, reportType, reportId);
  const download = findDictionaryReportType(dictionaryReports, 'downloads', code, reportType, reportId, 'reportId');

  return {
    isDownloading: download?.readStatus === states.PENDING,
    reportDate: report?.created_at,
    reportName: report?.name,
    rowCount: report?.metadata?.row_count,
    validationStatus: report?.metadata?.validation_status,
  };
};

const mapDispatchToProps = {
  downloadStart: dictionaryReportDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryReportsTableRow);
